import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AgitationSection } from './components/AgitationSection';
import { SteelStandard } from './components/SteelStandard';
import { IdentitySection } from './components/IdentitySection';
import { ImplementosSection } from './components/ImplementosSection';
import { ComparisonTable } from './components/ComparisonTable';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-gradient-to-b from-[#1A1A1B] to-[#121212] min-h-screen text-white font-sans selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <ImplementosSection data-id="element-5" />
        <SteelStandard data-id="element-6" />
        <ComparisonTable data-id="element-7" />
        <IdentitySection data-id="element-8" />
        <FAQ data-id="element-9" />
        <ContactForm data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}